import FA from 'admin/components/atoms/FontAwesome';
import React, { useState } from 'react';
import styled from 'styled-components';

const AccordionWrapper = styled.div<{ showBorder?: boolean }>`
  width: 100%;

  ${({ showBorder }) =>
    showBorder &&
    `
    border: 1px solid #cccccc;
    border-radius: 4px;
  `};
`;

const AccordionHeader = styled.div<{ showBorder?: boolean }>`
  width: 100%;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ showBorder }) =>
    showBorder &&
    `
    border-bottom: 1px solid #cccccc;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  `};
`;

const AccordionBody = styled.div`
  width: 100%;
  padding: 0 10px;
`;

const Icon = styled(FA)`
  font-size: 14px;
  color: #cccccc;
`;

const Accordion = ({
  renderHeader,
  renderBody,
  showIcon = true,
  showBorder = true,
}: {
  renderHeader: () => React.ReactNode;
  renderBody: () => React.ReactNode;
  showIcon?: boolean;
  showBorder?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <AccordionWrapper showBorder={showBorder}>
      <AccordionHeader onClick={toggleAccordion} showBorder={!!renderBody && isOpen && showBorder}>
        {renderHeader()}
        {showIcon && <Icon icon="chevron-down" rotation={isOpen ? 180 : undefined} />}
      </AccordionHeader>
      <AccordionBody>{!!renderBody && isOpen && renderBody()}</AccordionBody>
    </AccordionWrapper>
  );
};

export default Accordion;
